import React, { useEffect, useMemo, useState } from "react";
import * as S from "./ListPrograms.style";
import * as P from "../../../../../../../utils/pipes";
import { useTranslation } from "react-i18next";
import FlorenzButton from "../../../../../../florenzComponents/florenzButton";
import useRecordNavigation from "../../../../../../../hooks/useRecordNavigation";
import { Actions } from "../../../../../../../utils/actionsIds";

function ListPrograms({
  processList,
  frequency,
  processSelected,
  setProcessSelected,
  setStatusSelectionView
}) {

  const {t, i18n: { language }} = useTranslation("global");
  const { recordAction } = useRecordNavigation();  

  return (
    <S.ListPrograms>
      <div className="title">
        {t("changeOfStatus.updateChanges")}
      </div>
      <div className="program-list">
        {
          processList.map((process) => {
            return (
              <div className="program-item" 
                key={process.id}

              >
                <div className="program-item__top">
                  <div className="program-info">
                    <div className="program-title">
                      {P.dataTranslation(process.process.processName, language)}
                    </div>
                    <div className="program-stage">
                      {t("changeOfStatus.updateChanges")} <b>
                        {
                          process.processStage.groupStage
                            ? P.dataTranslation(process.processStage.groupStage.comment, language) + " - "
                            : ""
                        }
                        {
                          P.dataTranslation(process.processStage.stageName, language) + ` ${process.processStage?.incremental ? process.stageExtraInfo : ""}`
                        }
                      </b>
                    </div>
                  </div>
                  <div className="program-button">
                    <FlorenzButton
                      typeStyle={"secondary"}
                      size="s"
                      text={t("changeOfStatus.changeStatus")}
                      onClick={() => {
                        setProcessSelected(process.process.id);
                        setStatusSelectionView(1);
                        recordAction(Actions.STATUS_MANAGEMENT.CHANGE_STATUS, null, process.process.id);
                      }}
                      icon={"zaia-i-refresh"}
                    />
                  </div>
                </div>
                <div className="program-item__bottom">
                  <i className="program-icon-clock icon zaia-timeline"></i>
                  <div className="item">
                    <div className="item__title">
                      {t("aiNavigator.followUp")}
                    </div>
                    <div className="item__description">
                      {frequency(process.processStage)}
                    </div>
                  </div>
                  {
                    P.dataTranslation(process.processStage?.descript, language) &&
                    <>
                      <div className="items-separator"></div>
                      <div className="item">
                        <div className="item__title">
                          {t("changeOfStatus.aboutProgramStatusText")}
                        </div>
                        <div className="item__description">
                          {P.dataTranslation(process.processStage?.descript, language)}
                        </div>
                      </div>
                    </>
                  }
                </div>
              </div>
            );
          })
        }
      </div>
    </S.ListPrograms>
  );
}

export default ListPrograms;
